import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router){}

  /**
   * Authguard will use this to see if the user is able
   * to see the current webpage they are visiting
   */
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {

    if (await this.authService.isLoggedIn()) {
      return true;
    } else {
      this.router.navigateByUrl('/Login');
      return false;
    }
  }
}
